<template>
  <div class="step">
    <div class="line-wrap">
      <div class="line half"></div>
      <div class="active-line"></div>
    </div>
    <div class="step-list">
      <div class="step-item active">
        <span>选择商品</span>
        <span class="num right"></span>
      </div>
      <div class="step-item active">
        <span>填写核对订单</span>
        <span class="num">2</span>
      </div>
      <div class="step-item">
        <span>成功提交订单</span>
        <span class="num">3</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.step {
  padding: 58px 78px 42px;
  background: #fff;
  margin-top: 16px;
  border-radius: 12px;
  .line-wrap {
    position: relative;
    .line {
      width: 100%;
      height: 7px;
      border-radius: 11px;
      opacity: 0.1;
      background: linear-gradient(270deg, #2a54d1 0%, #5b85ff 100%);
    }
    .active-line {
      position: absolute;
      width: 50%;
      height: 7px;
      left: 0;
      top: 0;
      border-radius: 12.87px;
      background: #2a54d1;
      z-index: 9;
    }
  }

  .step-list {
    display: flex;
    justify-content: space-around;
    padding-top: 26px;
  }
  .step-item {
    position: relative;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: #666666;
    &.active {
      color: #333333;
      .num {
        color: #fff;
        background: linear-gradient(315deg, #2a54d1 0%, #5b85ff 100%);
        border: 2px solid rgba(255, 255, 255, 0.5);
        box-shadow: 0px 1.84px 7.36px 0px rgba(42, 84, 209, 0.5);
      }
    }
    .num {
      position: absolute;
      left: calc(50% - 21px);
      top: -52px;
      display: block;
      width: 43px;
      height: 43px;
      line-height: 39px;
      border-radius: 50%;
      color: #999999;
      font-weight: 700;
      background: #e1e3e6;
      box-sizing: border-box;
      border: 2px solid rgba(255, 255, 255, 0.5);
      box-shadow: 0px 1.84px 3.68px 0px rgba(153, 153, 153, 0.2);
      &.right {
        width: 66px;
        height: 66px;
        left: calc(50% - 33px);
        top: -63px;
        background: url('~@/assets/img/plc/right.png') no-repeat center;
        background-size: cover;
        box-shadow: none;
        border: 0;
      }
      z-index: 99;
    }
  }
}
</style>
